import { useState, useEffect } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Guarantee() {
  const iconRef = useScrollAnimation();
  const headlineRef = useScrollAnimation({ delay: 100 });
  const counterRef = useScrollAnimation({ delay: 200 });
  const contentRef = useScrollAnimation({ delay: 300 });
  const ctaRef = useScrollAnimation({ delay: 400 });
  
  const [spotsLeft, setSpotsLeft] = useState(3);

  useEffect(() => {
    // Animate the countdown from 5 to 3 on mount
    let count = 5;
    const interval = setInterval(() => {
      if (count > 3) {
        count--;
        setSpotsLeft(count);
      } else {
        clearInterval(interval);
      }
    }, 300);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        {/* Shield Icon */}
        <div ref={iconRef} className="animate-scale-up flex justify-center mb-6">
          <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-[#D4AF37] to-[#F4E5A1] rounded-full">
            <i className="ri-shield-check-fill text-4xl text-white"></i>
          </div>
        </div>

        {/* Main Guarantee Headline */}
        <h2 ref={headlineRef} className="animate-fade-up text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
          90-Day Results Guarantee<br />
          <span className="text-[#D4AF37]">or Your Money Back</span>
        </h2>

        {/* Spots Remaining Counter */}
        <div ref={counterRef} className="animate-scale-up inline-block bg-red-600 text-white px-6 py-3 rounded-lg mb-8">
          <div className="flex items-center gap-3">
            <i className="ri-time-line text-2xl"></i>
            <span className="text-lg font-bold">
              Only <span className="text-3xl mx-2">{spotsLeft}</span> of 5 Spots Left This Month
            </span>
          </div>
        </div>

        {/* Guarantee Explanation */}
        <div ref={contentRef} className="animate-fade-up bg-[#fafafa] border border-[#D4AF37]/30 rounded-xl p-8 mb-6">
          <p className="text-gray-600 text-lg leading-relaxed mb-6">
            I'm so confident in this program that if you follow the plan for 90 days and don't see measurable results in your physique, strength, and mindset, I'll refund every penny. No questions asked. No hoops to jump through.
          </p>
          <p className="text-gray-600 text-lg leading-relaxed">
            This isn't about taking your money. It's about transforming your life. If I can't deliver on that promise, you shouldn't pay. Simple as that.
          </p>
        </div>

        {/* Tagline */}
        <div className="flex items-center justify-center gap-4 text-[#B8860B] text-xl font-bold mb-8">
          <div className="h-px w-12 bg-[#B8860B]"></div>
          <span>No Risk. No Excuses. Just Results.</span>
          <div className="h-px w-12 bg-[#B8860B]"></div>
        </div>

        {/* CTA Button */}
        <div ref={ctaRef} className="animate-fade-up">
          <a
            href="#booking"
            className="inline-block bg-[#D4AF37] hover:bg-[#B8860B] text-black font-bold text-lg px-10 py-4 rounded-lg transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Claim Your Guaranteed Spot Now
          </a>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-6 mt-10 text-gray-500 text-sm">
          <div className="flex items-center gap-2">
            <i className="ri-lock-fill text-[#D4AF37]"></i>
            <span>Secure Payment</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-[#D4AF37]"></i>
            <span>Money-Back Guarantee</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-customer-service-2-line text-[#D4AF37]"></i>
            <span>24/7 Support</span>
          </div>
        </div>
      </div>
    </section>
  );
}